export function getSideMenus (routerJson, parent) {
  const list = []
  routerJson.forEach(el => {
    if (!el.hidden) {
      el.component = null
      const cur = {
        ...el,
        // path: (el.meta || {}).app && (/^\//).test(el.path) ? `/${el.meta.app}#${el.path}` : el.path,
      }
      if (cur.children && cur.children.length > 0) {
        cur.children = getSideMenus(cur.children, cur)
      }
      list.push(cur)
    }
  })
  return list
}
